module.exports = __webpack_public_path__ + "img/docker.2967976a.png";